var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCano(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-179 262.1 100 125",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-85 321.8c-1.7.4-3.3.8-4.9 1.2-24.4-21.1-80.5-25.9-82.3-26-11.6 54.8 77.3 63.2 77.3 63.2 10.9-10.1 9.9-38.4 9.9-38.4zm-63-17.6l-17.6 4.1c-2.5-3.3-3.9-6.4-4.8-8.6 2.8.5 11.5 1.8 22.4 4.5zm-12.9 9.3l22.2-6.8c13.5 4 28.4 9.8 38.9 18.1-33.7 5.5-51.6-2.5-61.1-11.3z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCano);
export default __webpack_public_path__ + "static/media/CANO.b7480fd8ab1b4949fe69b2c75ca38c6c.svg";
export { ForwardRef as ReactComponent };